// Boundary-safe prefix match: recognises nested step routes (e.g. redirects to
// `${path}/others/fields`) as belonging to their parent route. Keep the `+ '/'`
// boundary — a bare startsWith would risk sibling-route collisions.
const isNestedRouteActive = (currentPath: string, targetPath: string): boolean =>
  currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);

export default isNestedRouteActive;
